import Handlebars from 'handlebars';
import Commons from "oc-commons/Commons";
import Dialogs from "oc-ui/dialogs/DialogsJquery";
import I18N from 'oc-I18N';

export default class FormStammdaten {

    constructor(element, haendler, notCurrent=false) {
        this.template = Handlebars.compile($('#singleHaendlerTemplate').html());
        this.element = element;
        this.notCurrent=notCurrent;
        this.renderHaendler(haendler);

    }

    renderHaendler(haendler) {
        this.element.html(this.template(haendler, {data: {fromSuper: this.notCurrent}}));
        this.form = $('form', this.element);
        $('#loginpasswort', this.form).val(this.makeid(10));

        $('#saveHaendler', this.element).onSafe('tap', (context, event) => {
            event.preventDefault();
            this.sendData();
        });
        $('#uploadFileImage,#uploadFilePdf',this.element).hide();

        $('#uploadFilePdf', this.element).onSafe('tap', (context, event) => {
            event.preventDefault();
            this.sendFile({source:'#pdftemplate_file',target:"#PdfTemplate"});
        });

        $('#uploadFileImage', this.element).onSafe('tap', (context, event) => {
            event.preventDefault();
            this.sendFile({source:'#logo_file',target:"#Logo"});
        });

        $('#pdftemplate_file',this.element).onSafe('change',()=>{
            $('#uploadFilePdf',this.element).show();
        });

        $('#logo_file',this.element).onSafe('change',()=>{
            $('#uploadFileImage',this.element).show();
        });
    }

    sendFile(options) {
        let source,target;
        ({source,target}=options);
        const loginname = $('#loginname', this.form).val();

        const fileList = $(source, this.form)[0].files;
        const files = [];
        for (let i = 0; i < fileList.length; i++) {
            files.push(fileList.item(i));
        }


        if (files.length > 0) {
            const waiting = Dialogs.showWaiting(I18N('saving...'));
            APP.wkfgBackendApi.uploadContent('Haendler/' + loginname, files)
                .catch(a => this.showError(waiting, response))
                .then(
                    a => {
                        waiting.hide();
                        $(target,this.form).val(a[0]);
                        this.sendData();
                    });
        }
    }


    sendData() {
        const metadata = {};
        if ($('input:invalid', this.form).length > 0) {
            Dialogs.showWarning(I18N('Füllen Sie die Pflichtfelder aus.'));

        }
        this.form.serializeArray().forEach(v => metadata[v.name] = v.value);
        const waiting = Dialogs.showWaiting(I18N('saving...'));
        APP.wkfgBackendApi.saveMetadata('Haendler', Commons.isEmpty(metadata.id) ? 'create' : 'update', metadata)
            .then(data => {
                this.renderHaendler(data);
                //Object.keys(data).forEach(key=>$('[name="'+key+'"]').val(data[key]));
                waiting.hide();
                Dialogs.showToast(I18N('Gespeichert'));
            })
            .catch(response => this.showError(waiting, response));
    }

    showError(waiting, response) {
        waiting.hide();
        const warnings = [I18N('Nicht gespeichert')];
        if (response.responseJSON && response.responseJSON.error) {
            warnings.push(response.responseJSON.error.message);
        }

        Dialogs.showWarning(warnings.join('<br>'));
    }

    makeid(length) {
        var text = "";
        var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789()*!?_";
        for (var i = 0; i < length; i++)
            text += possible.charAt(Math.floor(Math.random() * possible.length));

        return text;
    }
}